export default "__VITE_ASSET__Cn68tOM9__"